import React from 'react'
import { Text, EmptyState, Heading } from 'base-ui'
import { PageWrapper } from './PageWrapper'
import { IconDocumentText } from '@paro.io/base-icons'
import Highlighter from './Highlight'
import { EmptyState as EmptyStateExample } from '../examples/EmptyState'

const Alerts = () => {
  return (
    <PageWrapper title="Empty State">
      <Text size="md">
        The empty state component is intended for use when a full page is empty or has no data to present, it contains a header to highlight what data is not present and a primary call to action, do not use for individual elements in the interface.
      </Text>
      <div className='py-8'>
      <EmptyState
          heading='Empty State Title or Reason'
          description='Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim venia.'
          buttonLabel='Action'
          buttonAction={() => console.log('clicked button!')}
          icon={<IconDocumentText/>}
          size={'lg'}
        />
      </div>
      <div>
        <EmptyState
          heading='Empty State Title or Reason'
          description='Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim venia.'
          buttonLabel='Action'
          buttonAction={() => console.log('clicked button!')}
          icon={<IconDocumentText/>}
          size={'md'}
        />
        </div>
      <Heading size="h3">Usage</Heading>
      <Highlighter code={EmptyStateExample} language='jsx' />
    </PageWrapper>
  )
}

export default Alerts
